import { getDefaultFilmingOffsetMonths } from "./dateUtils.js";

const SHOW_FILMING_OFFSET_PROFILES = {
  seinfeld: [
    { startSeason: 1, endSeason: 5, months: 2 },
    { startSeason: 6, endSeason: 9, months: 1 },
  ],
  "the-office": [
    { startSeason: 1, endSeason: 1, months: 7 },
    { startSeason: 2, endSeason: 9, months: 2 },
  ],
  "its-always-sunny": [
    { startSeason: 1, endSeason: 17, months: 2 },
  ],
  "parks-and-recreation": [
    { startSeason: 1, endSeason: 7, months: 2 },
  ],
  "brooklyn-nine-nine": [
    { startSeason: 1, endSeason: 8, months: 2 },
  ],
  "arrested-development": [
    { startSeason: 1, endSeason: 5, months: 2 },
  ],
  friends: [
    { startSeason: 1, endSeason: 10, months: 2 },
  ],
  "game-of-thrones": [
    { startSeason: 1, endSeason: 1, months: 9 },
    { startSeason: 2, endSeason: 7, months: 8 },
    { startSeason: 8, endSeason: 8, months: 9 },
  ],
  "the-sopranos": [
    { startSeason: 1, endSeason: 6, months: 3 },
  ],
  "modern-family": [
    { startSeason: 1, endSeason: 1, months: 2 },
    { startSeason: 2, endSeason: 11, months: 1 },
  ],
};

export function getShowDefaultFilmingOffsetMonths(showOrId, season) {
  const showId = typeof showOrId === "string" ? showOrId : showOrId?.id;
  const profile = showId ? SHOW_FILMING_OFFSET_PROFILES[showId] : null;

  if (!profile) {
    return getDefaultFilmingOffsetMonths(season);
  }

  const matchedRange = profile.find(
    (range) => season >= range.startSeason && season <= range.endSeason,
  );

  return matchedRange?.months ?? getDefaultFilmingOffsetMonths(season);
}
